module.exports = __webpack_public_path__ + "img/materials-and-equipments-hover-requests-manage.f2ec4cc4.svg";